import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=0ccd68e2&scoped=true&lang=scss"
script.__scopeId = "data-v-0ccd68e2"

export default script